// import hooks
import { useTranslation } from "react-i18next";
import { Link, NavLink } from "react-router-dom";
// import components

// import assets
// import { userFill, logOut, heart, requests } from "../../utils/cards-svgs"
// svgs will be set from css file as bg to change it's color

// import data

const AccountList = () => {
    const [t] = useTranslation("global");
    return (
        <ul className="account-list-ul">
            <NavLink to={"/orders"}>
                <li className="account-list-li">
                    <div className="order-svg ocean-svg"></div>
                    <span className="account-li-txt">
                        {t("account.list.requests")}
                    </span>
                </li>
            </NavLink>
            <NavLink to={"/wishlist"}>
                <li className="account-list-li active">
                    <div className="fill-heart-svg ocean-svg"></div>
                    <span className="account-li-txt">
                        {t("account.list.wish-list")}
                    </span>
                </li>
            </NavLink>
            <NavLink to={"/user"} className="my-nav-link">
                <li className="account-list-li">
                    <div className="user-fill-svg ocean-svg"></div>
                    <span className="account-li-txt">{t("account.list.info")}</span>
                </li>
            </NavLink>
            <li className="account-list-li logout-li">
                <div className="logout-svg ocean-svg red-svg"></div>
                <span className="account-li-txt red-txt">
                    {t("account.list.logout")}
                </span>
            </li>
        </ul>
    );
};

export default AccountList;
